export default "__VITE_ASSET__B1n7PamR__"